import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../../store/actions/notificationAction';

import addServicesRemote from '../../../../api/addServicesRemote';

import Customs from './CustomsFee';

import Cart from '../../../../models/Cart';
import FeeTotal from '../../../../models/FeeTotal';
import CartItem from '../../../../models/CartItem';
import FeeParams from '../../../../models/FeeParams';
import CartService from '../../../../models/CartService';
import ApiResponse from '../../../../models/ApiResponse';
import ResponseError from '../../../../models/ResponseError';
import AddServicesUnits from '../../../../models/AddServicesUnits';

import { CART_ITEM_SCHEMA, findCartItemByCodeAndNumber, findCartItemService } from '../../../../utils/cartService';

import Moment from 'moment';

interface CustomsProps {
  serviceDetails: AddServicesUnits;
  cart: Cart;
  selectedAwbCode: string;
  selectedAwbNumber: string;
  selectedAwbVer: number;
  pickupDate: Date;
  receiveError: Function;
  handleChange: any;
  additionalInformation: string;
};

interface CustomsState {
  cartItem: CartItem;
  calculations: FeeTotal;
  pickupDate: string;
};

class CustomsFeeContainer extends Component<CustomsProps, CustomsState> {
  
  state = {
    cartItem: CART_ITEM_SCHEMA,
    calculations: {
      days: 0,
      customs_fee: 0,
      storage_units: 0,
      total: 0,
      total_min_cost_usd: 0
    },
    pickupDate: ''
  }


  componentDidMount() {

    const cartItem: CartItem | undefined = findCartItemByCodeAndNumber(this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.cart);

    if (cartItem) {
      this.setState({ cartItem }, () => {
        this.loadData();
      });
    }
  }

  loadData = (): void => {
    
    let pickupDate: string = Moment(this.props.pickupDate).format('MMM DD, YY');
    let storageFeeService: CartService| undefined;
    if (this.state.cartItem.remainDue === 0) {

      storageFeeService = findCartItemService(this.state.cartItem, 'customs_fee');

      if (storageFeeService) {

        const calculations: FeeTotal = storageFeeService.calculations;

        if(storageFeeService.params.pickupdate) {
          pickupDate = Moment(storageFeeService.params.pickupdate).format('MMM DD, YY');
        }

        this.setState({ calculations });
      } else {
          this.loadCalculations(pickupDate);
      }
    } else {
      this.loadCalculations(pickupDate);
    }
    this.setState({ pickupDate });
  }

  loadCalculations = (pickupDate: string): void => {

    let optionalParams: FeeParams = {};
    optionalParams.pickupdate = Moment(pickupDate).format('YYYYMMDD');
    addServicesRemote.getFee('customs_fee', this.props.selectedAwbCode, this.props.selectedAwbNumber, this.props.selectedAwbVer, optionalParams).then((res: ApiResponse<FeeTotal>) => {

      const result: FeeTotal | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (result) {
        this.setState({ calculations: result });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  render () {

    const { serviceDetails } = this.props;
    const total: number = this.state.calculations.total || 0;

    return (
      <Customs
        serviceDetails={ serviceDetails }
        total={ total }
        calculations={ this.state.calculations }
        cartItemWeight={ this.state.cartItem.weight }
        handleChange={ this.props.handleChange }
        additionalInformation={ this.props.additionalInformation }
      />
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    cart: state.cart,
    pickupDate: state.pickupDate
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomsFeeContainer);